// components/CounterAnimation.jsx
import React, { useState, useEffect, useRef } from 'react';

// Set para guardar qué contadores ya se animaron
const animatedCounters = new Set();

const CounterAnimation = ({ end, suffix = '', duration = 2000 }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const [hasAnimated, setHasAnimated] = useState(false);
  const animationRef = useRef(null);

  // Crear un ID único para este contador específico
  const counterId = `${end}${suffix}`;

  useEffect(() => {
    // Si este contador ya se animó antes, mostrar valor final
    if (animatedCounters.has(counterId)) {
      setCount(end);
      setHasAnimated(true);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (
            entry.isIntersecting &&
            !hasAnimated &&
            !animatedCounters.has(counterId)
          ) {
            setHasAnimated(true);
            animatedCounters.add(counterId); // Registrar que este contador ya se animó
            animateCounter();
          }
        });
      },
      { threshold: 0.5 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, [hasAnimated, end, suffix, counterId]);

  const animateCounter = () => {
    const steps = 60;
    const stepDuration = duration / steps;
    const increment = end / steps;
    let currentCount = 0;

    if (animationRef.current) {
      clearInterval(animationRef.current);
    }

    animationRef.current = setInterval(() => {
      currentCount += increment;
      if (currentCount >= end) {
        setCount(end);
        clearInterval(animationRef.current);
      } else {
        setCount(Math.floor(currentCount));
      }
    }, stepDuration);
  };

  useEffect(() => {
    if (hasAnimated) {
      setCount(end);
    }
  }, [hasAnimated, end]);

  return (
    <span ref={ref}>
      {count}
      {suffix}
    </span>
  );
};

export default CounterAnimation;
